const ValetDataActionTypes = {
  GET_VALET_FLIGHT_IDS_START: 'GET_VALET_FLIGHT_IDS_START',
  GET_VALET_FLIGHT_IDS_SUCCESS: 'GET_VALET_FLIGHT_IDS_SUCCESS',
  GET_VALET_FLIGHT_IDS_FAILURE: 'GET_VALET_FLIGHT_IDS_FAILURE',

  GET_VALET_FLIGHT_TIMES_START: 'GET_VALET_FLIGHT_TIMES_START',
  GET_VALET_FLIGHT_TIMES_SUCCESS: 'GET_VALET_FLIGHT_TIMES_SUCCESS',
  GET_VALET_FLIGHT_TIMES_FAILURE: 'GET_VALET_FLIGHT_TIMES_FAILURE',

  // TODO: Connect to backend for data
  GET_VALET_FLIGHT_DELAY_START: 'GET_VALET_FLIGHT_DELAY_START',
  GET_VALET_FLIGHT_DELAY_SUCCESS: 'GET_VALET_FLIGHT_DELAY_SUCCESS',
  GET_VALET_FLIGHT_DELAY_FAILURE: 'GET_VALET_FLIGHT_DELAY_FAILURE',

  FILTER_VALET_FLIGHTS_START: 'FILTER_VALET_FLIGHTS_START',
  FILTER_VALET_FLIGHTS_SUCCESS: 'FILTER_VALET_FLIGHTS_SUCCESS',
  FILTER_VALET_FLIGHTS_FAILURE: 'FILTER_VALET_FLIGHTS_FAILURE',

  SET_VALET_DOF: 'SET_VALET_DOF',

  SET_VALET_CUSTOMER_COUNT: 'SET_VALET_CUSTOMER_COUNT',
  SET_VALET_FLIGHT_ID_LOADING: 'SET_VALET_FLIGHT_ID_LOADING',
  SET_VALET_CUSTOMER_DATA_LOADING: 'SET_VALET_CUSTOMER_DATA_LOADING',

  SET_VALET_SELECTED_FLIGHT_IDS: 'SET_VALET_SELECTED_FLIGHT_IDS',

  SET_VALET_DESTINATION: 'SET_VALET_DESTINATION',
  GET_VALET_DESTINATION: 'GET_VALET_DESTINATION',

  SET_VALET_FILTERED_FLIGHT_IDS: 'SET_VALET_FILTERED_FLIGHT_IDS',
  GET_VALET_FILTERED_FLIGHT_IDS: 'GET_VALET_FILTERED_FLIGHT_IDS',

  SET_VALET_FILTER_TIME_START: 'SET_VALET_FILTER_TIME_START',
  SET_VALET_FILTER_TIME_END: 'SET_VALET_FILTER_TIME_END',

  GET_VALET_FILTER_TIME_START: 'GET_VALET_FILTER_TIME_START',
  GET_VALET_FILTER_TIME_END: 'GET_VALET_FILTER_TIME_END',

  GET_VALET_CUSTOMER_DATA_START: 'GET_VALET_CUSTOMER_DATA_START',
  GET_VALET_CUSTOMER_DATA_SUCCESS: 'GET_VALET_CUSTOMER_DATA_SUCCESS',
  GET_VALET_CUSTOMER_DATA_FAILURE: 'GET_VALET_CUSTOMER_DATA_FAILURE',
};

export default ValetDataActionTypes;
